import Vue from 'vue'
import Vuex from 'vuex'
import Auth from './modules/Auth'
import M0001User from '@/components/functions/M0001User/M0001UserStore'
import M0101Branch from '@/components/functions/M0101Branch/M0101BranchStore'
import M0201Chapter from '@/components/functions/M0201Chapter/M0201ChapterStore'
import M0201Chapters from '@/components/functions/M0201Chapters/M0201ChaptersStore'
import M0202Title from '@/components/functions/M0202Title/M0202TitleStore'
import M0203Question from '@/components/functions/M0203Question/M0203QuestionStore'
import M0204Answer from '@/components/functions/M0204Answer/M0204AnswerStore'
import M0301CommissionSetting from '@/components/functions/M0301CommissionSetting/M0301CommissionSettingStore'
import M0302CommissionRecord from '@/components/functions/M0302CommissionRecord/M0302CommissionRecordStore'
import M0303CommissionPayment from '@/components/functions/M0303CommissionPayment/M0303CommissionPaymentStore'
import M0401Class from '@/components/functions/M0401Class/M0401ClassStore'
import M0402ClassInstructor from '@/components/functions/M0402ClassInstructor/M0402ClassInstructorStore'
import M0403ClassStudent from '@/components/functions/M0403ClassStudent/M0403ClassStudentStore'
import M0404ClassUnit from '@/components/functions/M0404ClassUnit/M0404ClassUnitStore'
import M0405ClassUnitAttendant from '@/components/functions/M0405ClassUnitAttendant/M0405ClassUnitAttendantStore'
import M0501Course from '@/components/functions/M0501Course/M0501CourseStore'
import M0502CourseLevel from '@/components/functions/M0502CourseLevel/M0502CourseLevelStore'
import M0503MaterialLicense from '@/components/functions/M0503MaterialLicense/M0503MaterialLicenseStore'
import M0601Instructor from '@/components/functions/M0601Instructor/M0601InstructorStore'
import M0602Student from '@/components/functions/M0602Student/M0602StudentStore'
import S0101DataImport from '@/components/functions/S0101DataImport/S0101DataImportStore'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    Auth,
    M0001User,
    M0101Branch,
    M0201Chapter,
    M0201Chapters,
    M0202Title,
    M0203Question,
    M0204Answer,
    M0301CommissionSetting,
    M0302CommissionRecord,
    M0303CommissionPayment,
    M0401Class,
    M0402ClassInstructor,
    M0403ClassStudent,
    M0404ClassUnit,
    M0405ClassUnitAttendant,
    M0501Course,
    M0502CourseLevel,
    M0503MaterialLicense,
    M0601Instructor,
    M0602Student,
    S0101DataImport
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js